import axios from 'axios'
import { LiaVenusMarsSolid } from 'react-icons/lia';
//    baseURL: "https://bento-backend-849680057939.asia-south2.run.app/admin/",

// https://bento-backend-version2-849680057939.asia-south2.run.app/admin/
    // baseURL: "http://localhost:8080/admin/",
    //https://backend.getbentobox.in/admin/
    const localurl = "http://localhost:8080/admin/"
    const liveurl = "https://backend.getbentobox.in/admin/"
    console.log("CLONE BUILD V2 🚀");
const apiClient = axios.create({
       baseURL:liveurl,
    headers:{
        "Access-Control-Allow-Origin":"*",
        "Content-type":"application/json; charset=UTF-8"
    },
})
function getAuthToken() {
    return localStorage.getItem("bentoAdmin");
}
apiClient.interceptors.request.use(config => {
    const token = getAuthToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => Promise.reject(error));

// apiClient.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (error.response && error.response.status === 401) {
//             localStorage.removeItem("bentoAdmin");
//             localStorage.removeItem("bentoAdminExpiry");
//             window.location.href = "/login";
//         }
//         return Promise.reject(error);
//     }
// );

export default apiClient